import React from 'react';
import { Link } from 'react-router-dom';
import './ErrorGeneratingSchedule.css'; // Import the CSS

const ErrorGeneratingSchedule = () => {
  return (
    <div className="error-container">
      <h1 className="error-title">Oops! Something Went Wrong</h1>
      <p className="error-description">
        We were unable to generate your schedule. Please try again.
      </p>
      <div className="error-image">
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2-13h4v6h-4zm0 8h4v2h-4z"/>
        </svg>
      </div>
      <Link to="/">
        <button className="error-button">Go Back to Home</button>
      </Link>
    </div>
  );
};

export default ErrorGeneratingSchedule;
